<!-- <app-header-one [sticky]="true"></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup" >
  <div class="popup-container">
    <div class="popup-card">

      <h1 style="text-align: center;">TERMS &amp; CONDITIONS </h1>

      <p><strong>Last Updated:</strong> 12th June, 2026</p>

      <p>
          Welcome to www.neojobz.com (<strong>“NeoJobz”, “Neojobz.com”, “we”, “our”, “us”</strong>)!
      </p>

      <p>
          Thank you for visiting NeoJobz. NeoJobz appeals you to give a careful read through the following pages for you to comprehend all our terms &amp; conditions. It takes just a few minutes.
      </p>

      <p>
          These Terms and Conditions (<strong>“Terms &amp; Conditions”, “Terms”, “Terms of Use”, “Terms of Service”, “Service Terms”</strong>)
          govern your use of <u>NeoJobz</u>'s webpages located at www.neojobz.com and on our mobile application at
          <u>NeoJobz</u> App (together or individually <strong>“Services”</strong>) is operated by JoJo Techland Pvt. Ltd.
      </p>

      <p>
          Our Privacy Policy also governs your use of our services and explains how we collect,
          safeguard and disclose information that results from your use of our web pages.
      </p>

      <p>
          When you use our service, you acknowledge that you have read and understood our services,
          and agree to be bound by them. Your agreement with us includes these Terms &amp; Conditions,
          and our Privacy Policy (<strong>“Agreement”</strong>). If you do not agree or cannot comply with
          our Agreement, then you may not use our Services at all. But, if you wish to and face any
          challenge, please let us know by emailing to our customers support so we can try to find a
          solution. These Terms of Use apply to all visitors, users and others who wish to access or
          use our Services. We thank you for being responsible.
      </p>

      <h2>COMMUNICATIONS</h2>

      <p>
          By creating your Account at our Services, you agree to subscribe to newsletters,
          marketing or promotional materials and other information we may send from time to time.
          However, you may opt out from receiving any of our communications by following the
          unsubscribe link or by emailing at
          <a href="mailto:support@neojobz.com">support&#64;neojobz.com</a>.
      </p>

      <h2>PURCHASES</h2>

      <p>
          If you wish to purchase, any product or service through our Services
          (<strong>“Purchase(s)”</strong>), you may be asked to supply certain information relevant
          to your Purchase including, without limitation, your full name on the credit card,
          your credit card number, the expiration date of your credit card, your CVV number,
          your billing address, and your shipping information etc.
      </p>

      <p>
          You represent &amp; warrant that:
      </p>

      <p>
          <strong>(i)</strong> You have the legal right to use your credit card(s) or other payment method(s)
          in connection with any Purchase.
      </p>

      <p>
          <strong>(ii)</strong> The information you supply to NeoJobz is correct and complete.
      </p>
        
      <p>
          We may employ the third-party services for the purpose of facilitating payment,
          and the completion of Purchases. By submitting your information, you grant us
          the right to provide the information to these third parties in accordance to our
          Privacy Policy.We reserve the right to refuse or cancel your order at any time for reasons including but not limited to: product or service availability, errors in the price or description of the product or service, error in your order, or other reasons. Moreover, we reserve the right to refuse or cancel your order if fraud or an unauthorized or illegal transaction is suspected.
      </p>
      
      <h2>SALES &amp; ADVERTISING</h2>

      <p>
          If you wish to sell or promote any product, service or concept through our Services
          (<strong>“Sale(s)”, “Advertising(s)”, “Promotion(s)”</strong>), you may be asked to
          supply certain information relevant to your selling or advertising promotions including,
          without limitation, your firm’s full name registered as per MCA, your Bank, CIN, TAN,
          PAN, GST details, your operating office address, and your shipping information etc.
      </p>

      <p>
          You represent &amp; warrant that:
      </p>

      <p><strong>(i)</strong> You have the legal right to operate or receive any payment in connection with any Purchase as a legal entity as per the law of the land.</p>

      <p><strong>(ii)</strong> The information you supply to NeoJobz is correct and complete.</p>

      <h2>CONTESTS, SWEEPSTAKES AND PROMOTIONS</h2>

      <p>
          Any contests, sweepstakes or promotions (collectively,
          <strong>“Sales Promotions”</strong>) made available through our Services may be governed
          by rules that are separate from these Terms of Service.
      </p>

      <p>
          If you participate in any Sales Promotions, please review the applicable rules as well as
          our Privacy Policy. If the rules for a Sales Promotion conflict with these Terms of
          Service, Promotion rules will apply.
      </p>

      <h2>SUBSCRIPTIONS</h2>

      <p>
          Some parts of our Services are billed on a subscription basis
          (<strong>“Subscription(s)”</strong>). You will be billed in advance on a recurring and
          periodic basis (<strong>“Billing Cycle”</strong>). Billing cycles are set on a specific
          plan basis, monthly, quarterly, semester or annual basis, depending on the type of
          subscription plan you select when purchasing a Subscription.
      </p>

      <p>
          At the end of each Billing Cycle, your Subscription will automatically renew under the
          exact same conditions unless you cancel it or NeoJobz cancels it. You may cancel your
          Subscription renewal either through your online account management page or by
          contacting NeoJobz’s customer support team.
      </p>

      <p>
          A valid payment method, including credit card or PayPal, is required to process the
          payment for your subscription. You shall provide NeoJobz with accurate and complete
          billing information including your full name, address, state, zip code, telephone number,
          email id, and valid payment method information. By submitting such payment
          information, you automatically authorize NeoJobz to charge all Subscription fees
          incurred through your account to any such payment instruments.
      </p>

      <p>
          Should automatic billing fail to occur for any reason, NeoJobz will issue an electronic
          invoice indicating that you must proceed manually, within a certain deadline date, with
          the full payment corresponding to the billing period as indicated on the invoice.
      </p>

      <h2>FREE TRIAL</h2>

      <p>
          NeoJobz may offer a Subscription with a free trial, at its sole discretion, for a
          limited period of time (<strong>“Free Trial”</strong>). You may be required to enter
          your billing information in order to sign up for Free Trial.
      </p>

      <p>
          If you do enter your billing information when signing up for Free Trial, you will not
          be charged by NeoJobz until Free Trial has expired. On the last day of the Free Trial
          period, unless you cancel your Subscription, you will be automatically charged the
          applicable Subscription fees for the type of Subscription you have selected.
      </p>
      
      <p>
          At any time and without notice, NeoJobz reserves the right to:
      </p>

      <p>
          <strong>(i)</strong> Modify the Terms of Service of the Free Trial offer.
      </p>

      <p>
          <strong>(ii)</strong> Cancel such Free Trial offer.
      </p>

      <h2>FEE CHANGES</h2>

      <p>
          NeoJobz, in its sole discretion and at any time, may modify Subscription fees for the
          Subscriptions. Any Subscription fee change will become effective at the end of the
          then-current Billing Cycle.
      </p>

      <p>
          NeoJobz will provide you with reasonable prior notice of any change in Subscription
          fees to give you an opportunity to terminate your Subscription before such change
          becomes effective.
      </p>

      <p>
          Your continued use of Service after a Subscription fee change constitutes your
          agreement to pay the modified Subscription fee amount.
      </p>

      <h2>REFUNDS</h2>

      <p>
          Except when required by law, paid Subscription fees are non-refundable. We issue
          refunds for Contracts within 90 days of the original purchase of the Contract upon
          submission of relevant information as required.
      </p>

      <h2>CONTENT</h2>

      <p>
          Our Service allows you to post, link, store, share and otherwise make available
          certain information, text, images, graphics, videos, or other material
          (<strong>“Content”</strong>). You are responsible for Content that you post on or
          through our Services, including its legality, reliability, and appropriateness.
      </p>

      <p>
          By posting Content on or through our Services, you represent and warrant that:
          (i) Content is yours (you own it) and/or you have the right to use it and the right
          to grant us the rights and license as provided in these Terms; and
          (ii) the posting of your Content on or through our Services does not violate the
          privacy rights, publicity rights, copyrights, contract rights, or any other rights
          of any person or entity. We reserve the right to terminate the account of anyone
          found to be infringing on a copyright.
      </p>

      <p>
          You retain any and all of your rights to any Content you submit, post or display on
          or through our Services, and you are responsible for protecting those rights.
          NeoJobz takes no responsibility and assumes no liability for Content you or any
          third party posts on or through our Services.
      </p>

      <p>
          However, by posting Content using our Services, you grant us the right and license
          to use, modify, publicly perform, publicly display, reproduce, and distribute such
          Content on and through our Services. You agree that this license includes the right
          for us to make your Content available to other users of our Services, who may also
          use your Content subject to these Terms.
      </p>

      <p>
          NeoJobz has the right but not the obligation to monitor and edit all Content
          provided by users.
      </p>

      <h2>PROHIBITED USES</h2>

      <p>
          You may use our Services only for lawful purposes and in accordance with our Terms.
          You agree not to use our Services:
      </p>
      
      <p><strong>1.</strong> In any way that violates any applicable national or international law or regulation.</p>

      <p><strong>2.</strong> For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content or otherwise.</p>

      <p><strong>3.</strong> To transmit, or procure the sending of, any advertising or promotional material, including any “junk mail”, “chain letter”, “spam”, or any other similar solicitation.</p>

      <p><strong>4.</strong> To impersonate or attempt to impersonate Company, a Company employee, another user, or any other person or entity.</p>

      <p><strong>5.</strong> In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity.</p>

      <p><strong>6.</strong> To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of Service, or which, as determined by NeoJobz, may harm or offend Company or users of our Services, or expose them to liability.</p>

      <p>
          Additionally, you agree not to:
                
      <p><strong>1.</strong> Use our Services in any manner that could disable, overburden, damage, or impair Service or interfere with any other party’s use of our Services, including their ability to engage in real-time activities through Service.</p>

      <p><strong>2.</strong> Use any robot, spider, or other automatic device, process, or means to access our Services for any purpose, including monitoring or copying any material on our Services.</p>

      <p><strong>3.</strong> Use any manual process to monitor or copy any material on our Services or for any other unauthorized purpose without our prior written consent.</p>

      <p><strong>4.</strong> Use any device, software, or routine that interferes with the proper working of our Services.</p>

      <p><strong>5.</strong> Introduce any viruses, trojan horses, worms, logic bombs, or other material which is malicious or technologically harmful, or hack our Services.</p>

      <p><strong>6.</strong> Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of our Services, the server on which our Services are stored, or any server, computer, or database connected to Service.</p>

      <p><strong>7.</strong> Attack our Services via a denial-of-service attack or a distributed denial-of-service attack.</p>

      <p><strong>8.</strong> Take any action that may damage or falsify Company rating.</p>

      <p><strong>9.</strong> Otherwise attempt to interfere with the proper working of our Services.</p>

      <h2>ANALYTICS</h2>

      <p>
          NeoJobz may use third-party Service Providers to monitor and analyze the use of our
          Services in various forms on a regular basis.
      </p>

      <h4>Google Analytics</h4>

      <p>
          Google Analytics is a web analytics service offered by Google that tracks and reports
          website traffic. Google uses the data collected to track and monitor the use of our
          Service. This data is shared with other Google services. Google may use the collected
          data to contextualize and personalize the adverts of its own advertising network.
      </p>

      <p>
          For more information on the privacy practices of Google, please visit the Google Privacy
          Terms web page. Further, we also encourage you to review Google's policy for
          safeguarding your data.
      </p>

      <h2>NO USE BY MINORS</h2>

      <p>
          NeoJobz’s Services are intended only for access and use by individuals at least eighteen
          (18yrs) years old. By accessing or using any of NeoJobz’s Services, you warrant and
          represent that you are at least eighteen (18yrs) years of age and with the full authority,
          right, and capacity to enter into this agreement and abide by all of the terms and
          conditions of Terms.
      </p>

      <p>
          If you are not at least eighteen (18yrs) years old, you are prohibited from both the
          access and usage of our Services.
      </p>

      <h2>ACCOUNTS</h2>

      <p>
          When you create an account with us, you guarantee that you are above the age of 18
          years, and that the information you provide us is accurate, complete, and current at all
          times. Inaccurate, incomplete, or obsolete information may result in the immediate
          termination of your account on our Services.
      </p>

      <p>
          You are responsible for maintaining the confidentiality of your account and password,
          including but not limited to the restriction of access to your computer and/or account.
          You agree to accept responsibility for any and all activities or actions that occur under
          your account and/or password, whether your password is with our Services or a
          third-party service.
      </p>

      <p>
          You must notify us immediately upon becoming aware of any breach of security or
          unauthorized use of your account.
      </p>

      <p>
          You may not use as a username the name of another person or entity or that is not
          lawfully available for use, a name or trademark that is subject to any rights of another
          person or entity other than you, without appropriate authorization. You may not use as
          a username any name that is offensive, vulgar, forbidden, or obscene.
      </p>

      <p>
          We reserve the right to refuse our services, terminate accounts, remove or edit content,
          or cancel orders in our sole discretion.
      </p>

      <h2>INTELLECTUAL PROPERTY</h2>

      <p>
          NeoJobz’s Services and its original content (excluding Content provided by users),
          features and functionality are and will remain the exclusive property of JoJo Techland
          P.L.C. and its licensors. Service is protected by copyright, trademark, and other laws
          of India and foreign countries.
      </p>

      <p>
          Our trademarks and trade dress may not be used in connection with any product or
          service without the prior written consent of JoJo Techland P.L.C.
      </p>

      <h2>COPYRIGHT POLICY</h2>

      <p>
          NeoJobz respects the intellectual property rights of others. It is our policy to
          respond to any claim that Content posted on our Services infringes on the copyright
          or other intellectual property rights (<strong>“Infringement”</strong>) of any person
          or entity.
      </p>

      <p>
          If you are a copyright owner, or authorized on behalf of one, and you believe that
          the copyrighted work has been copied in a way that constitutes copyright infringement,
          please submit your claim via email to Copyright Agent, with the subject line:
          <strong>“Copyright Infringement”</strong> and include in your claim a detailed
          description of the alleged Infringement as detailed below, under
          <strong>“DMCA Notice and Procedure for Copyright Infringement Claims”</strong>.
      </p>

      <p>
          You may be held accountable for damages (including costs and attorneys' fees) for
          misrepresentation or bad-faith claims on the infringement of any Content found on
          and/or through our Services on your copyright.
      </p>

      <h2>ERROR REPORTING AND FEEDBACK</h2>

      <p>
          You may provide us either directly at
          <a href="mailto:support@neojobz.com">support&#64;neojobz.com</a>
          or via third party sites and tools with information and feedback concerning errors,
          suggestions for improvements, ideas, problems, complaints, and other matters related
          to our Service (<strong>“Feedback”</strong>).
      </p>

      <p>
          You acknowledge and agree that:
          (i) you shall not retain, acquire or assert any intellectual property right or other
          right, title or interest in or to the Feedback;
          (ii) NeoJobz may have development ideas similar to the Feedback;
          (iii) Feedback does not contain confidential information or proprietary information
          from you or any third party; and
          (iv) NeoJobz is not under any obligation of confidentiality with respect to the Feedback.
      </p>

      <p>
          In the event the transfer of ownership to the Feedback is not possible due to applicable
          mandatory laws, you grant NeoJobz and its affiliates an exclusive, transferable,
          irrevocable, free-of-charge, sub-licensable, unlimited and perpetual right to use
          (including copy, modify, create derivative works, publish, distribute and commercialize)
          Feedback in any manner and for any purpose.
      </p>

      <h2>LINKS TO OTHER WEB SITES</h2>

      <p>
          NeoJobz Services may contain links to third party websites or services that are not
          owned or controlled by NeoJobz.
      </p>

      <p>
          NeoJobz has no control over, and assumes no responsibility for the content, privacy
          policies, or practices of any third-party web sites or services. We do not warrant
          the offerings of any of these entities, individuals, or their websites.
      </p>

      <p>
          <strong>
              YOU ACKNOWLEDGE AND AGREE THAT NEOJOBZ SHALL NOT BE RESPONSIBLE OR LIABLE,
              DIRECTLY OR INDIRECTLY, FOR ANY DAMAGE OR LOSS CAUSED OR ALLEGED TO BE CAUSED
              BY OR IN CONNECTION WITH USE OF OR RELIANCE ON ANY SUCH CONTENT, GOODS OR
              SERVICES AVAILABLE ON OR THROUGH ANY SUCH THIRD-PARTY WEBSITES OR SERVICES.
          </strong>
      </p>

      <p>
          <strong>
              WE STRONGLY ADVISE YOU TO READ THE TERMS OF SERVICE AND PRIVACY POLICIES OF
              ANY THIRD-PARTY WEBSITES OR SERVICES THAT YOU VISIT.
          </strong>
      </p>

      <h2>DISCLAIMER OF WARRANTY</h2>

      <p>
          <strong>
              THESE SERVICES ARE PROVIDED BY NEOJOBZ ON AN “AS IS” AND “AS AVAILABLE” BASIS.
              NEOJOBZ MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
              AS TO THE OPERATION OF THEIR SERVICES, OR THE INFORMATION, CONTENT OR MATERIALS
              INCLUDED THEREIN. YOU EXPRESSLY AGREE THAT YOUR USE OF OUR SERVICES, THEIR CONTENT,
              AND ANY SERVICES OR ITEMS OBTAINED FROM US IS AT YOUR SOLE RISK.
          </strong>
      </p>

      <p>
          <strong>
              NEITHER NEOJOBZ NOR ANY PERSON ASSOCIATED WITH NEOJOBZ MAKES ANY WARRANTY OR
              REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY,
              ACCURACY, OR AVAILABILITY OF THE SERVICES.
          </strong>
      </p>

      <p>
          WITHOUT LIMITING THE FOREGOING, NEITHER COMPANY NOR ANYONE ASSOCIATED WITH COMPANY
          REPRESENTS OR WARRANTS THAT THE SERVICES, THEIR CONTENT, OR ANY SERVICES OR ITEMS
          OBTAINED THROUGH OUR SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR
          UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SERVICES OR THE SERVER
          THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT
          THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH OUR SERVICES WILL OTHERWISE
          MEET YOUR NEEDS OR EXPECTATIONS.
      </p>

      <p>
          <strong>
              NEOJOBZ HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
              STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
              MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE.
          </strong>
      </p>

      <p>
          THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED
          UNDER APPLICABLE LAW.
      </p>

      <h2>LIMITATION OF LIABILITY</h2>

      <p>
          EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS, DIRECTORS,
          EMPLOYEES, AND AGENTS HARMLESS FOR ANY INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL,
          OR CONSEQUENTIAL DAMAGE, HOWEVER IT ARISES (INCLUDING ATTORNEYS' FEES AND ALL
          RELATED COSTS AND EXPENSES OF LITIGATION AND ARBITRATION, OR AT TRIAL OR ON
          APPEAL, IF ANY, WHETHER OR NOT LITIGATION OR ARBITRATION IS INSTITUTED),
          WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR
          ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT.
      </p>

      <p>
          INCLUDING WITHOUT LIMITATION ANY CLAIM FOR PERSONAL INJURY OR PROPERTY DAMAGE,
          ARISING FROM THIS AGREEMENT AND ANY VIOLATION BY YOU OF ANY FEDERAL, STATE, OR
          LOCAL LAWS, STATUTES, RULES, OR REGULATIONS, EVEN IF COMPANY HAS BEEN PREVIOUSLY
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </p>

      <p>
          EXCEPT AS PROHIBITED BY LAW, IF THERE IS LIABILITY FOUND ON THE PART OF NEOJOBZ,
          IT WILL BE LIMITED TO THE AMOUNT PAID FOR THE PRODUCTS AND/OR SERVICES, AND UNDER
          NO CIRCUMSTANCES WILL THERE BE CONSEQUENTIAL OR PUNITIVE DAMAGES.
      </p>

      <h2>TERMINATION</h2>

      <p>
          We may terminate or suspend your account and bar access to our Services immediately,
          without prior notice or liability, under our sole discretion, for any reason whatsoever,
          and without limitation, including but not limited to a breach of Terms.
      </p>

      <p>
          If you wish to terminate your account, you may simply discontinue using our Services.
      </p>
      
      <p>
        All provisions of Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
      </p>

      <h2>GOVERNING LAW</h2>

      <p>
          These Terms shall be governed and construed in accordance with the laws of India,
          which governing law applies to this agreement without regard to its conflict of law
          provisions.
      </p>

      <p>
          Our failure to enforce any right or provision of these Terms will not be considered a
          waiver of those rights. If any provision of these Terms is held to be invalid or
          unenforceable by a court, the remaining provisions of these Terms will remain in
          effect.
      </p>

      <p>
          These Terms constitute the entire agreement between us regarding our Services and
          supersede and replace any prior agreements we might have had between us regarding
          our Services.
      </p>

      <h2>CHANGES TO SERVICE</h2>

      <p>
          We reserve the right to withdraw or amend our Services, and any service or material
          we provide via our Services, in our sole discretion without notice.
      </p>

      <p>
          We will not be liable if for any reason all or any part of our Services are unavailable
          at any time or for any period.
      </p>

      <p>
          From time to time, we may restrict access to some parts of our Services, or to the
          entire Services, to users, including registered users.
      </p>

      <h2>AMENDMENTS TO TERMS</h2>

      <p>
          We may amend Terms of Service at any time by posting the amended terms on this site.
          It is your responsibility to review these Terms periodically.
      </p>

      <p>
          Your continued use of the Platform following the posting of revised Terms means that
          you accept and agree to the changes. You are expected to check this page frequently
          so you are aware of any changes, as they are binding on you.
      </p>

      <h2>WAIVER AND SEVERABILITY</h2>

      <p>
          No waiver by Company of any term or condition set forth in Terms shall be deemed a
          further or continuing waiver of such term or condition or a waiver of any other term
          or condition, and any failure of Company to assert a right or provision under Terms
          shall not constitute a waiver of such right or provision.
      </p>

      <p>
          If any provision of Terms is held by a court or other tribunal of competent jurisdiction
          to be invalid, illegal or unenforceable for any reason, such provision shall be eliminated
          or limited to the minimum extent such that the remaining provisions of Terms will continue
          in full force and effect.
      </p>

      <h2>ACKNOWLEDGMENT</h2>

      <p>
          BY USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF SERVICE
          AND AGREE TO BE BOUND BY THEM.
      </p>

      <h2>CONTACT US</h2>

      <p>
          Please send your feedback, comments, or requests for technical support:
      </p>
        
      <p>
        <strong>By email:</strong>
        <a href="mailto:support@neojobz.com">
            support&#64;neojobz.com
        </a>
      </p>

    <p>
        <strong>By visiting:</strong>
        Contact Form on Contact Us Page
    </p>

    <p>
        <strong>By phone number:</strong>
        +91-70 75 74 5784
    </p>



      <!-- <h2 class="title" >{{tncData.title}}</h2>
      <div [innerHTML]="tncData.description"></div> -->

<!-- 
      <p>Welcome to WhiteRobe App (<strong>“WhiteRobe”, “whiterobe.in”, “we”, “our”, “us”</strong>)!</p>
      <p>Thank you for visiting WhiteRobe. WhiteRobe appeals you to give a careful read through the following pages for
        you to comprehend all our terms & conditions. It takes just a few minutes.</p>
      <p>These Terms of Service (<strong>“Terms”, “Terms of Use”, “Terms of Service”, “Service Terms”</strong>) govern
        your use of WhiteRobe’s webpages located at www.whiterobe.in and on our mobile application at WhiteRobe App
        (together or individually <strong>“Services”</strong>) is operated by JoJo Techland Pvt. Ltd.</p>
      <p>Our Privacy Policy also governs your use of our Service and explains how we collect, safeguard and disclose
        information that results from your use of our web pages.</p>
      <p>When you use our service, you acknowledge that you have read and understood our services, and agree to be bound
        by them. Your agreement with us includes these Terms & Conditions, and our Privacy Policy
        (<strong>“Agreement”</strong>). If you do not agree or cannot comply with our Agreement, then you may not use
        our Services at all. But, if you wish to and face any challenge, please let us know by emailing to our customers
        support so we can try to find a solution. These Terms of Use apply to all visitors, users and others who wish to
        access or use our Services. We thank you for being responsible.</p>

      <h2>COMMUNICATIONS</h2>
      <p>By creating your Account at our Services, you agree to subscribe to newsletters, marketing or promotional
        materials and other information we may send from time to time. However, you may opt out from receiving any of
        our communications by following the unsubscribe link or by emailing at <b>contact&#64;whiterobe.in</b></p>
      <h2>PURCHASES</h2>
      <p>If you wish to purchase, any product or service through our Services (<strong>“Purchase(s)”</strong>), you may
        be asked to supply certain information relevant to your Purchase including, without limitation, your full name
        on the credit card, your credit card number, the expiration date of your credit card, your CVV number, your
        billing address, and your shipping information etc.
        You represent & warrant that: (i) you have the legal right to use your credit card(s) or other payment method(s)
        in connection with any Purchase; and that (ii) the information you supply to WhiteRobe is correct and complete.
        We may employ the third party services for the purpose of facilitating payment, and the completion of Purchases.
        By submitting your information, you grant us the right to provide the information to these third parties in
        accordance to our Privacy Policy.
        We reserve the right to refuse or cancel your order at any time for reasons including but not limited to:
        product or service availability, errors in the price or description of the product or service, error in your
        order, or other reasons. Moreover, we reserve the right to refuse or cancel your order if fraud or an
        unauthorized or illegal transaction is suspected.

      </p>
      <h2>SALES & ADVERTISING</h2>
      <p>If you wish to sell or promote any product, service or concept through our Services (<strong>“Sale(s)”,
          “Advertising(s)”, “Promotion(s)”</strong>), you may be asked to supply certain information relevant to your
        selling or advertising promotions including, without limitation, your firm’s full name registered as per MCA,
        your Bank, CIN, TAN, PAN, GST details, your operating office address, and your shipping information etc.
        You represent & warrant that: (i) you have the legal right to operate or receive any payment in connection with
        any Purchase as legal entity as per the law of the land; and that (ii) the information you supply to WhiteRobe
        is correct and complete.
      </p>
      <h2>CONTESTS, SWEEPSTAKES AND PROMOTIONS</h2>
      <p>Any contests, sweepstakes or promotions (collectively, <strong>“Sales Promotions”</strong>) made available
        through our Services may be governed by rules that are separate from these Terms of Service. If you participate
        in any Sales Promotions, please review the applicable rules as well as our Privacy Policy. If the rules for a
        Sales Promotion conflict with these Terms of Service, Promotion rules will apply.
      </p>
      <h2>CANCELLATION</h2>
      <p>Some parts of our Services are billed on a subscription basis. You will be billed in advance on a recurring and
        periodic basis (<strong>“Billing Cycle”</strong>). Billing cycles are set on a specific plan basis, monthly,
        quarterly, semester or annual basis, depending on the type of subscription plan you select when purchasing a
        Subscription.
        At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions
        unless you cancel it or WhiteRobe cancels it. You may cancel your Subscription renewal either through your
        online account management page or by contacting WhiteRobe’s customer support team
        (<strong>“Cancellation(s)”</strong>).
        A valid payment method, including credit card or PayPal, is required to process the payment for your
        subscription. You shall provide WhiteRobe with accurate and complete billing information including your full
        name, address, state, zip code, telephone number, email id, and a valid payment method information. By
        submitting such payment information, you automatically authorize WhiteRobe to charge all Subscription fees
        incurred through your account to any such payment instruments.
        Should automatic billing fail to occur for any reason, WhiteRobe will issue an electronic invoice indicating
        that you must proceed manually, within a certain deadline date, with the full payment corresponding to the
        billing period as indicated on the invoice.</p>

      <h2>REFUNDS</h2>
      <p>Except when required by law, paid Subscription fees are non-refundable. We issue refunds for Contracts within
        90 days of the original purchase of the Contract on submission of relevant information as required.</p>

      <h2>FREE TRIAL</h2>
      <p>WhiteRobe may offer a Subscription with a free trial, at its sole discretion, for a limited period of time
        (<strong>“Free Trial”</strong>). You may be required to enter your billing information in order to sign up for
        Free Trial.
        If you do enter your billing information when signing up for Free Trial, you will not be charged by WhiteRobe
        until Free Trial has expired. On the last day of Free Trial period, unless you cancelled your Subscription, you
        will be automatically charged the applicable Subscription fees for the type of Subscription you have selected.
        At any time and without notice, WhiteRobe reserves the right to (i) modify Terms of Service of Free Trial offer,
        or (ii) cancel such Free Trial offer.</p>



      <h2>CONTENT</h2>
      <p>Our Service allows you to post, link, store, share and otherwise make available certain information, text,
        images, graphics, videos, or other material (“Content”). You are responsible for Content that you post on or
        through our Services, including its legality, reliability, and appropriateness.
        By posting Content on or through our Services, You represent and warrant that: (i) Content is yours (you own it)
        and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms,
        and (ii) that the posting of your Content on or through our Services does not violate the privacy rights,
        publicity rights, copyrights, contract rights, or any other rights of any person or entity. We reserve the right
        to terminate the account of anyone found to be infringing on a copyright.
        You retain any and all of your rights to any Content you submit, post or display on or through our Services, and
        you are responsible for protecting those rights. WhiteRobe takes no responsibility and assume no liability for
        Content you or any third party posts on or through our Services. However, by posting Content using our Services
        you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute
        such Content on and through our Services. You agree that this license includes the right for us to make your
        Content available to other users of our Services, who may also use your Content subject to these Terms.
        WhiteRobe has the right but not the obligation to monitor and edit all Content provided by users.</p>

      <h2>PROHIBITED USES</h2>
      <p>You may use our Services only for lawful purposes and in accordance with our Terms. You agree not to use our
        Services:</p>

      <ul>
        <li>
          <p>1. In any way that violates any applicable national or international law or regulation.</p>
        </li>
        <li>
          <p>2. For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing
            them to inappropriate content or otherwise.</p>
        </li>
        <li>
          <p>3. To transmit, or procure the sending of, any advertising or promotional material, including any “junk
            mail”, “chain letter,” “spam,” or any other similar solicitation.</p>
        </li>
        <li>
          <p>4. To impersonate or attempt to impersonate Company, a Company employee, another user, or any other person
            or entity.</p>
        </li>
        <li>
          <p> 5. In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent,
            or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity.</p>
        </li>
        <li>
          <p>6. To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of Service, or
            which, as determined by WhiteRobe, may harm or offend Company or users of our Services, or expose them to
            liability.</p>
        </li>
      </ul>

      <div class="row mt-3"></div>
      <p><strong>Additionally, you agree not to:</strong></p>
      <ul>
        <li>
          <p>1. Use our Services in any manner that could disable, overburden, damage, or impair Service or interfere
            with any other party’s use of our Services, including their ability to engage in real time activities
            through Service.</p>
        </li>
        <li>
          <p> 2. Use any robot, spider, or other automatic device, process, or means to access our Services for any
            purpose, including monitoring or copying any of the material on our Services.</p>
        </li>
        <li>
          <p> 3. Use any manual process to monitor or copy any of the material on our Services or for any other
            unauthorized purpose without our prior written consent.</p>
        </li>
        <li>
          <p> 4. Use any device, software, or routine that interferes with the proper working of our Services.</p>
        </li>
        <li>
          <p> 5. Introduce any viruses, trojan horses, worms, logic bombs, or other material which is malicious or
            technologically harmful, or hack our Services.</p>
        </li>
        <li>
          <p> 6. Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of our Services,
            the server on which our Services are stored, or any server, computer, or database connected to Service.</p>
        </li>
        <li>
          <p> 7. Attack our Services via a denial-of-services attack or a distributed denial-of-services attack.</p>
        </li><br>
        <li>
          <p> 8. Take any action that may damage or falsify Company rating.</p>
        </li><br>
        <li>
          <p> 9. Otherwise attempt to interfere with the proper working of our Services.</p>
        </li>
      </ul>
      <h2>ANALYTICS</h2>
      <p>WhiteRobe may use third-party Service Providers to monitor and analyze the use of our Services in various forms
        on a regular basis.
        <strong>Google Analytics</strong>
        Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google
        uses the data collected to track and monitor the use of our Service. This data is shared with other Google
        services. Google may use the collected data to contextualise and personalise the adverts of its own advertising
        network.
        For more information on the privacy practices of Google, please visit the Google Privacy Terms web page.
        Further, we also encourage you to review the Google's policy for safeguarding your data.
      </p>

      <h2>NO USE BY MINORS</h2>
      <p>WhiteRobe’s Services are intended only for access and use by individuals at least eighteen (18yrs) years old.
        By accessing or using any of WhiteRobe’s Services, you warrant and represent that you are at least eighteen
        (18yrs) years of age and with the full authority, right, and capacity to enter into this agreement and abide by
        all of the terms and conditions of Terms. If you are not at least eighteen (18yrs) years old, you are prohibited
        from both the access and usage of our Services.</p>
      <h2>ACCOUNTS</h2>
      <p>When you create an account with us, you guarantee that you are above the age of 18 years, and that the
        information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete
        information may result in the immediate termination of your account on our Services.
        You are responsible for maintaining the confidentiality of your account and password, including but not limited
        to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all
        activities or actions that occur under your account and/or password, whether your password is with our Services
        or a third-party service. You must notify us immediately upon becoming aware of any breach of security or
        unauthorized use of your account.
        You may not use as a username the name of another person or entity or that is not lawfully available for use, a
        name or trademark that is subject to any rights of another person or entity other than you, without appropriate
        authorization. You may not use as a username any name that is offensive, vulgar or obscene.
        We reserve the right to refuse our services, terminate accounts, remove or edit content, or cancel orders in our
        sole discretion.
      </p>
      <h2>INTELLECTUAL PROPERTY</h2>
      <p>WhiteRobe’s Services and its original content (excluding Content provided by users), features and functionality
        are and will remain the exclusive property of JoJo Techland P.L.C. and its licensors. Service is protected by
        copyright, trademark, and other laws of India and foreign countries. Our trademarks and trade dress may not be
        used in connection with any product or service without the prior written consent of JoJo Techland P.L.C.</p>
      <h2>COPYRIGHT POLICY</h2>
      <p>WhiteRobe respects the intellectual property rights of others. It is our policy to respond to any claim that
        Content posted on our Services infringes on the copyright or other intellectual property rights
        (<strong>“Infringement”</strong>) of any person or entity.
        If you are a copyright owner, or authorized on behalf of one, and you believe that the copyrighted work has been
        copied in a way that constitutes copyright infringement, please submit your claim via email to Copyright Agent,
        with the subject line: “Copyright Infringement” and include in your claim a detailed description of the alleged
        Infringement as detailed below, under “DMCA Notice and Procedure for Copyright Infringement Claims”
        You may be held accountable for damages (including costs and attorneys' fees) for misrepresentation or bad-faith
        claims on the infringement of any Content found on and/or through our Services on your copyright.
      </p>
      <h2>ERROR REPORTING AND FEEDBACK</h2>
      <p>You may provide us either directly at contact&#64;whiterobe.in or via third party sites and tools with
        information and feedback concerning errors, suggestions for improvements, ideas, problems, complaints, and other
        matters related to our Service (<strong>“Feedback”</strong>). You acknowledge and agree that: (i) you shall not
        retain, acquire or assert any intellectual property right or other right, title or interest in or to the
        Feedback; (ii) WhiteRobe may have development ideas similar to the Feedback; (iii) Feedback does not contain
        confidential information or proprietary information from you or any third party; and (iv) WhiteRobe is not under
        any obligation of confidentiality with respect to the Feedback. In the event the transfer of the ownership to
        the Feedback is not possible due to applicable mandatory laws, you grant WhiteRobe and its affiliates an
        exclusive, transferable, irrevocable, free-of-charge, sub-licensable, unlimited and perpetual right to use
        (including copy, modify, create derivative works, publish, distribute and commercialize) Feedback in any manner
        and for any purpose.</p>
      <h2>LINKS TO OTHER WEB SITES</h2>
      <p>WhiteRobe Services may contain links to third party websites or services that are not owned or controlled by
        WhiteRobe.
        WhiteRobe has no control over, and assumes no responsibility for the content, privacy policies, or practices of
        any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or
        their websites.
        YOU ACKNOWLEDGE AND AGREE THAT WhiteRobe SHALL NOT BE RESPONSIBLE OR LIABLE, DIRECTLY OR INDIRECTLY, FOR ANY
        DAMAGE OR LOSS CAUSED OR ALLEGED TO BE CAUSED BY OR IN CONNECTION WITH USE OF OR RELIANCE ON ANY SUCH CONTENT,
        GOODS OR SERVICES AVAILABLE ON OR THROUGH ANY SUCH THIRD PARTY WEBSITES OR SERVICES.
        WE STRONGLY ADVISE YOU TO READ THE TERMS OF SERVICE AND PRIVACY POLICIES OF ANY THIRD PARTY WEBSITES OR SERVICES
        THAT YOU VISIT.
      </p>
      <h2>DISCLAIMER OF WARRANTY </h2>
      <p>THESE SERVICES ARE PROVIDED BY WHITEROBE ON AN “AS IS” AND “AS AVAILABLE” BASIS. WHITEROBE MAKES NO
        REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR SERVICES, OR THE
        INFORMATION, CONTENT OR MATERIALS INCLUDED THEREIN. YOU EXPRESSLY AGREE THAT YOUR USE OF OUR SERVICES, THEIR
        CONTENT, AND ANY SERVICES OR ITEMS OBTAINED FROM US IS AT YOUR SOLE RISK.
        NEITHER WHITEROBE NOR ANY PERSON ASSOCIATED WITH WHITEROBE MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO
        THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE SERVICES. WITHOUT LIMITING
        THE FOREGOING, NEITHER COMPANY NOR ANYONE ASSOCIATED WITH COMPANY REPRESENTS OR WARRANTS THAT THE SERVICES,
        THEIR CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH OUR SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR
        UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SERVICES OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE
        OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH OUR
        SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
        WHITEROBE HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE,
        INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR
        PURPOSE.
        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
      </p>

      <h2>LIMITATION OF LIABILITY</h2>
      <p>EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS HARMLESS FOR
        ANY INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGE, HOWEVER IT ARISES (INCLUDING ATTORNEYS'
        FEES AND ALL RELATED COSTS AND EXPENSES OF LITIGATION AND ARBITRATION, OR AT TRIAL OR ON APPEAL, IF ANY, WHETHER
        OR NOT LITIGATION OR ARBITRATION IS INSTITUTED), WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, OR OTHER TORTIOUS
        ACTION, OR ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY CLAIM FOR
        PERSONAL INJURY OR PROPERTY DAMAGE, ARISING FROM THIS AGREEMENT AND ANY VIOLATION BY YOU OF ANY FEDERAL, STATE,
        OR LOCAL LAWS, STATUTES, RULES, OR REGULATIONS, EVEN IF COMPANY HAS BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY
        OF SUCH DAMAGE. EXCEPT AS PROHIBITED BY LAW, IF THERE IS LIABILITY FOUND ON THE PART OF WHITEROBE, IT WILL BE
        LIMITED TO THE AMOUNT PAID FOR THE PRODUCTS AND/OR SERVICES, AND UNDER NO CIRCUMSTANCES WILL THERE BE
        CONSEQUENTIAL OR PUNITIVE DAMAGES.</p>
      <h2>TERMINATION</h2>
      <p>We may terminate or suspend your account and bar access to our Services immediately, without prior notice or
        liability, under our sole discretion, for any reason whatsoever, and without limitation, including but not
        limited to a breach of Terms.
        If you wish to terminate your account, you may simply discontinue using our Services.
        All provisions of Terms which by their nature should survive termination shall survive termination, including,
        without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
      </p>
      <h2>GOVERNING LAW</h2>
      <p>These Terms shall be governed and construed in accordance with the laws of India, which governing law applies
        to agreement without regard to its conflict of law provisions.
        Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If
        any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of
        these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Services
        and supersede and replace any prior agreements we might have had between us regarding our Services.
      </p>
      <h2>CHANGES TO SERVICE</h2>
      <p>We reserve the right to withdraw or amend our Services, and any service or material we provide via our
        Services, in our sole discretion without notice. We will not be liable if for any reason all or any part of our
        Services are unavailable at any time or for any period. From time to time, we may restrict access to some parts
        of our Services, or on the entire Services, to users, including registered users.</p>
      <h2>AMENDMENTS TO TERMS</h2>
      <p>We may amend Terms of Service at any time by posting the amended terms on this site. It is your responsibility
        to review these Terms periodically.
        Your continued use of the Platform following the posting of revised Terms means that you accept and agree to the
        changes. You are expected to check this page frequently so you are aware of any changes, as they are binding on
        you.
        By continuing to access or use our Services after any revisions become effective, you agree to be bound by the
        revised terms. If you do not agree to the new terms, you are no longer authorized to use our Services.
      </p>
      <h2>WAIVER AND SEVERABILITY</h2>
      <p>No waiver by WhiteRobe of any term or condition set forth in Terms shall be deemed a further or continuing
        waiver of such term or condition or a waiver of any other term or condition, and any failure of WhiteRobe to
        assert a right or provision under Terms shall not constitute a waiver of such right or provision.
        If any provision of Terms is held by a court or other tribunal of competent jurisdiction to be invalid, illegal
        or unenforceable for any reason, such provision shall be eliminated or limited to the minimum extent such that
        the remaining provisions of Terms will continue in full force and effect.
      </p>
      <h2>ACKNOWLEDGEMENT</h2>
      <p>BY USING OUR SERVICES OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF
        SERVICE AND AGREE TO BE BOUND BY THEM.</p>
      <h2>CONTACT US</h2>
      <p style="text-align: center;">Please send your feedback, comments, requests for technical support:<br>
        By email: contact&#64;whiterobe.in<br>
        By visiting: Contact Form on Contact Us Page<br>
        By phone number: +91-70 75 85 5784<br>
         Address: India, Canada, UK
      </p> -->
    </div>
  </div>
</section>
<!-- <app-footer-one></app-footer-one> -->
<app-footer-more-info></app-footer-more-info>
